import { createApiSlice } from "@common/common-slice/commonSlice";

import {
  GET_PROJ_UNIQUE_USERS
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "getProjectUser",
    method: "get",
    url: GET_PROJ_UNIQUE_USERS,
    stateKey: "data",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    levelLoading: false,
    data: [],
    dataByRole: [],
    userGroupForProj: [],
    userRolesForProj: [],
    userRolesLevel: [],
    mainData: [],
    notProjectUsersData: [],
  },
  reducers: {
    resetRowSelect: (state, action) => {
      state.selectedData = {};
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "projectUsers",
  apiConfig,
  customReducers,
);
const projectUsersSlice = slice;
// Export the slice's reducer
export default projectUsersSlice.reducer;

// Dynamically export all actions
export const actionsExports = actions;

// Destructure and export thunks directly from thunksExports
export const {
  getProjectUser
} = thunks;
